var _path, _path2, _circle, _circle2, _circle3, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _g, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _g2, _path41, _path42, _path43, _path44, _path45, _path46, _g3, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _g4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgHub = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 17,
  height: 16,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#a)"
}, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M15.065 6.564A6.564 6.564 0 0 0 8.5 0a6.55 6.55 0 0 0-6.564 6.497 6.565 6.565 0 0 0 3.953 6.091c.392.17.728.45.968.804l1.175 1.727c.225.33.711.33.936 0l1.175-1.727a2.25 2.25 0 0 1 .965-.802 6.566 6.566 0 0 0 3.957-6.026Z",
  fill: "#FE5F00"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M8.5 10.69a4.126 4.126 0 1 0 0-8.252 4.126 4.126 0 0 0 0 8.253Z",
  fill: "url(#b)"
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 8.5,
  cy: 8,
  r: 8,
  fill: "#F7E7D5"
})), /*#__PURE__*/React.createElement("mask", {
  id: "c",
  style: {
    maskType: "alpha"
  },
  maskUnits: "userSpaceOnUse",
  x: 0,
  y: 0,
  width: 17,
  height: 16
}, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
  cx: 8.5,
  cy: 8,
  r: 8,
  fill: "#FE5F00"
}))), /*#__PURE__*/React.createElement("g", {
  mask: "url(#c)"
}, _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
  cx: 11.202,
  cy: 15.467,
  r: 8.569,
  fill: "#FE5F00"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "m13.417 6.61-4.77-1.38-4.762 1.38v6.458h9.532V6.61Z",
  fill: "url(#d)"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M13.3 6.75 8.532 5.336 3.775 6.722v-.41L8.53 4.825l4.77 1.548v.376Z",
  fill: "#0E4174"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  d: "m13.3 6.547 3.627-1.802v6.693L13.3 13.006V6.547Z",
  fill: "url(#e)"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  d: "m13.9 7.355 1.513-.599v1.527l-1.514.66V7.355Z",
  fill: "url(#f)"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  d: "m15.063 6.893.35-.137v1.527l-.35.155V6.893Z",
  fill: "url(#g)"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  d: "M13.9 8.646v.296l1.513-.659-.316-.12-1.197.483Z",
  fill: "url(#h)"
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  d: "m18.938 4.327.088-.444-5.732 2.429.007.437 5.637-2.422Z",
  fill: "#041A43"
})), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
  d: "M13.644 6.648 8.53 5.168 3.358 6.662l-.148-.518L8.53 4.657l5.227 1.547-.114.444Z",
  fill: "url(#i)"
})), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
  d: "M11.579 7.28H5.504v5.726h6.075V7.28Z",
  fill: "url(#j)"
})), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M5.504 7.28h.168v5.726h-.168",
  fill: "#0E4174"
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  opacity: 0.2,
  fillRule: "evenodd",
  clipRule: "evenodd",
  fill: "#003A8C"
}, /*#__PURE__*/React.createElement("path", {
  d: "M5.84 7.711c0-.039.065-.07.147-.07h5.109c.082 0 .148.031.148.07 0 .04-.066.071-.148.071h-5.11c-.08 0-.147-.031-.147-.07ZM5.84 8.138c0-.04.065-.071.147-.071h5.109c.082 0 .148.032.148.071 0 .04-.066.071-.148.071h-5.11c-.08 0-.147-.032-.147-.071ZM5.84 8.565c0-.04.065-.071.147-.071h5.109c.082 0 .148.031.148.07 0 .04-.066.072-.148.072h-5.11c-.08 0-.147-.032-.147-.071ZM5.84 8.991c0-.039.065-.07.147-.07h5.109c.082 0 .148.031.148.07 0 .04-.066.072-.148.072h-5.11c-.08 0-.147-.032-.147-.072ZM5.84 9.418c0-.04.065-.071.147-.071h5.109c.082 0 .148.032.148.071 0 .04-.066.071-.148.071h-5.11c-.08 0-.147-.032-.147-.071ZM5.84 9.845c0-.04.065-.071.147-.071h5.109c.082 0 .148.031.148.07 0 .04-.066.072-.148.072h-5.11c-.08 0-.147-.032-.147-.071ZM5.84 10.271c0-.039.065-.07.147-.07h5.109c.082 0 .148.031.148.07 0 .04-.066.071-.148.071h-5.11c-.08 0-.147-.031-.147-.07ZM5.84 10.698c0-.04.065-.071.147-.071h5.109c.082 0 .148.032.148.071 0 .04-.066.071-.148.071h-5.11c-.08 0-.147-.032-.147-.07ZM5.84 11.125c0-.04.065-.071.147-.071h5.109c.082 0 .148.031.148.07 0 .04-.066.072-.148.072h-5.11c-.08 0-.147-.032-.147-.071ZM5.84 11.551c0-.039.065-.07.147-.07h5.109c.082 0 .148.031.148.07 0 .04-.066.071-.148.071h-5.11c-.08 0-.147-.031-.147-.07ZM5.84 11.978c0-.04.065-.071.147-.071h5.109c.082 0 .148.032.148.071 0 .04-.066.071-.148.071h-5.11c-.08 0-.147-.032-.147-.07ZM5.84 12.405c0-.04.065-.071.147-.071h5.109c.082 0 .148.032.148.07 0 .04-.066.072-.148.072h-5.11c-.08 0-.147-.032-.147-.071ZM5.84 12.831c0-.039.065-.07.147-.07h5.109c.082 0 .148.031.148.07 0 .04-.066.072-.148.072h-5.11c-.08 0-.147-.032-.147-.072Z"
}))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
  d: "M14.162 2.255 8.773 3.77 3.21 6.144l5.335-1.48 5.617-2.409Z",
  fill: "url(#k)"
})), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
  d: "m14.162 2.255 5.207 1.534-5.61 2.415-5.214-1.54 5.617-2.409Z",
  fill: "url(#l)"
})), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
  d: "M9.237 4.401 4.01 5.834l-.37.122 5.227-1.433.37-.122ZM9.903 4.119 4.676 5.552l-.363.12L9.54 4.24l.363-.121ZM10.576 3.836 5.35 5.27l-.363.121 5.227-1.433.363-.12ZM11.249 3.554 6.022 4.987l-.364.12 5.228-1.425.363-.128ZM11.935 3.258 6.708 4.69l-.363.12 5.227-1.432.363-.121ZM12.581 2.975 7.354 4.408l-.37.121 5.227-1.433.37-.12ZM13.2 2.713 7.973 4.146l-.364.12 5.228-1.432.363-.121ZM13.805 2.457 8.578 3.89l-.363.121 5.227-1.426.363-.128Z",
  fill: "#FE7A2B"
})), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
  d: "m19.282 4.24.087-.45-5.61 2.414-.115.451 5.638-2.415Z",
  fill: "#B24300"
})), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
  d: "m3.424 6.654-.155-.518v-.007h.007l1.325-.383 1.326-.384 2.664-.747h.02l2.61.78 1.299.398 1.305.403-1.312-.37L11.2 5.45l-2.61-.767h.02l-2.664.74-1.332.363-1.339.356.007-.006.141.518Z",
  fill: "#FFDC9C"
})), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
  d: "m8.51 4.623 4.165-1.735L8.538 4.69l-.027-.068Z",
  fill: "#FFDC9C"
})), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
  d: "M12.02 13.43c-.22-.06-.582-.06-.803 0l-4.356 1.166c-.22.06-.167.212-.106.247.061.036.179.094.83.194.372.057.622.048.845.001 1.014-.19 3.45-.862 4.286-1.174.283-.106.07-.234-.15-.293l-.546-.142Z",
  fill: "#121619",
  opacity: 0.1
})), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M11.726 13.553c-.22-.059-.45-.023-.671.036l-3.966 1.063c-.221.059-.387.149-.166.208 0 0 .11.045.274.075.163.03.437.08.73.05.622-.067 3.085-.815 3.403-.898.516-.133.749-.238.82-.286.07-.048.098-.12-.123-.18l-.301-.068Z",
  fill: "#121619"
})), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
  d: "M11.865 12.275a.41.41 0 0 0-.094-.013c.173.14.248.43.167.728-.088.327-.332.553-.575.551.042.035.09.06.143.074.27.072.57-.17.67-.539.1-.37-.04-.73-.31-.801Z",
  fill: "#A2A9B0"
})), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
  d: "M11.357 12.854c-.026.1.011.197.085.217.073.02.155-.046.181-.146.027-.1-.01-.197-.084-.217-.073-.02-.155.046-.182.146Z",
  fill: "#A2A9B0"
})), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
  d: "m11.442 13.071.144.039.097-.363-.144-.038-.097.362Z",
  fill: "#A2A9B0"
})), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
  d: "M11.5 12.892c-.028.1.01.197.084.217.073.02.154-.046.181-.146.027-.1-.01-.197-.084-.217-.074-.02-.155.046-.182.146Z",
  fill: "#697077"
})), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
  d: "m12.045 12.621-.373.1.187-.448-.16-.072-.187.449-.187-.348-.16.156.187.349-.374.1v.228l.374-.1-.186.448.159.07.187-.448.186.35.16-.157-.186-.35.373-.1v-.227Z",
  fill: "#697077"
})), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
  d: "M11.404 12.848c-.022.079.008.155.066.17.057.016.12-.036.141-.114.022-.079-.008-.155-.065-.17-.058-.015-.12.036-.142.114ZM12.045 12.621l.108.032-.373.1-.108-.032.373-.1ZM11.807 13.485l-.109-.03-.186-.35.108.031.187.349Z",
  fill: "#697077"
})), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
  d: "m12.153 12.653-.373.1.186-.45-.16-.07-.186.448-.187-.348-.16.157.187.348-.373.1v.227l.373-.099-.187.449.16.07.187-.449.187.349.16-.157-.187-.348.373-.1v-.227Z",
  fill: "#C1C7CD"
})), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
  d: "M11.512 12.88c-.021.079.008.154.066.17.057.015.12-.037.142-.115.021-.078-.009-.154-.066-.17-.057-.015-.121.036-.142.115Z",
  fill: "#C1C7CD"
})), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
  d: "M11.914 12.092c-.344-.093-.726.214-.852.685-.126.47.05.928.396 1.02.344.092.726-.215.852-.686.126-.47-.05-.926-.396-1.019Zm.263.984c-.1.37-.4.612-.67.539-.27-.073-.41-.432-.312-.802.1-.37.4-.612.67-.538.272.072.41.43.312.801Z",
  fill: "#21272A"
})), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
  d: "M11.418 12.862c-.049.18.02.353.15.389.132.035.278-.082.325-.262.048-.18-.02-.353-.151-.388-.132-.035-.277.081-.324.261Z",
  fill: "#697077"
})), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
  d: "m11.568 13.25.068.019.174-.65-.068-.018-.174.65Z",
  fill: "#697077"
})), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
  d: "M11.48 12.879c-.048.18.02.353.15.388.132.035.278-.081.325-.261.048-.18-.02-.353-.15-.388-.131-.036-.277.081-.325.26Z",
  fill: "#21272A"
})), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
  d: "M11.457 13.797c-.344-.092-.521-.548-.395-1.02.126-.47.508-.777.852-.684a.487.487 0 0 1 .15.07.995.995 0 0 0-.607-.172c-.304.008-.607.292-.716.702-.11.408.01.807.269.965a.99.99 0 0 0 .61.156.57.57 0 0 1-.162-.017Z",
  fill: "#343A3F"
})), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
  d: "M10.555 13.285c.052-.004 1.152-.14 1.152-.14l.046-.662-1.006.2-.192.602ZM9.428 13.717l1.012.272.058-.115-1.012-.272-.058.115Z",
  fill: "#21272A"
})), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
  d: "M10.418 14.26a.074.074 0 0 1-.049-.087l.222-1.022c.009-.033.147.005.127.108-.014.077-.204.945-.204.945a.075.075 0 0 1-.096.055ZM9.514 13.804a.074.074 0 0 1-.05-.086l.223-1.022c.008-.034.147.004.127.107-.015.078-.204.945-.204.945a.073.073 0 0 1-.096.056Z",
  fill: "#21272A"
})), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
  d: "M7.28 10.395c-.009.042.008.083.04.09.03.006.063-.022.073-.065.01-.042-.007-.083-.039-.09-.03-.007-.064.021-.073.065Z",
  fill: "#4D5358"
})), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
  d: "m7.319 10.493 1.919.453.035-.162-1.92-.454-.034.163Z",
  fill: "#21272A"
})), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
  d: "M9.196 10.855c-.01.042.007.083.038.09.031.007.065-.021.075-.064.01-.042-.007-.083-.039-.09-.03-.008-.064.021-.074.064Z",
  fill: "#121619"
})), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
  d: "M8.544 13.783s.575.114.715.068c.14-.045 1.058-.329 1.167-.41.107-.08 1.453-1.516 1.554-1.656.1-.14.068-.631.068-.685 0-.054-.97-.256-1.014-.23l-1.252.685c-.002.01-.242 1.407-.453 1.527a2.33 2.33 0 0 1-.528.221c-.234-.31-.478-.693-.497-.811-.032-.213.032-1.195.184-1.503l-.81-.151s-.871 1.526-.638 1.884l.492.79 1.012.27Z",
  fill: "url(#m)"
})), /*#__PURE__*/React.createElement("mask", {
  id: "o",
  style: {
    maskType: "alpha"
  },
  maskUnits: "userSpaceOnUse",
  x: 7,
  y: 10,
  width: 5,
  height: 4
}, _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
  d: "M8.5 13.698s.559.11.694.066c.136-.044 1.028-.32 1.134-.397.104-.079 1.411-1.474 1.51-1.61.098-.136.066-.613.066-.665 0-.053-.943-.249-.985-.225-.041.025-1.217.667-1.217.667-.002.009-.235 1.366-.44 1.483a2.266 2.266 0 0 1-.512.215c-.228-.301-.465-.673-.483-.788-.031-.207.03-1.16.178-1.46l-.709-.174s-.924 1.51-.697 1.857l.477.767.984.264Z",
  fill: "url(#n)"
}))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#o)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M8.315 12.49c.033.205.77 1.204.903 1.17.132-.034.866-.233 1.082-.35.215-.116.449-1.043.486-1.275.037-.232-.381-.309-.381-.309l-.632-.067s-1.491.626-1.458.831Z",
  fill: "#21272A"
}))), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
  d: "m8.801 13.304.34.389.816-.269-.866-.232-.29.112Z",
  fill: "#121619"
})), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
  d: "M8.486 11c-.068.128-.297 1.077-.257 1.53.019.216.795 1.221.961 1.216.146-.005.951-.28 1.12-.356.27-.12.521-1.269.579-1.486.057-.216.845-.515.931-.569.086-.054.231-.098.232-.047 0 .05.12.352.1.41-.022.057-1.496 1.908-1.496 1.908s-.704.213-.868.254c-.163.04-1.11.096-1.146.093-.036-.002-.266-.217-.266-.217s-1.348-1.01-1.343-1.069c0 0-.084-.244.178-.175.361.093.511-.22.607-.454.372-.91-.071-.85.026-1.025.096-.177.642-.013.642-.013Z",
  fill: "url(#p)"
})), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
  d: "M9.676 11.842s.111.015.208.063c.098.048.16.175.191.444.017.145-.027.558-.12.925-.037.145.156.162.279-.051.122-.213.472-.968.386-1.206-.086-.237-.178-.344-.199-.355-.022-.012-.745.18-.745.18Z",
  fill: "url(#q)"
})), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
  d: "m7.099 12.645.64.171a.637.637 0 0 1 .378.281l.45.81-1.035-.396-.49-.79c-.026-.04.011-.088.057-.076Z",
  fill: "#121619"
})), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
  d: "m7.926 10.477-.217.43s.002.053.08.075c.14.04.35.084.47.07.148-.017.23-.062.23-.062s.138-.235.158-.273c.092-.167-.084-.377-.35-.411-.276-.036-.37.171-.37.171Z",
  fill: "url(#r)"
})), /*#__PURE__*/React.createElement("mask", {
  id: "t",
  style: {
    maskType: "alpha"
  },
  maskUnits: "userSpaceOnUse",
  x: 7,
  y: 10,
  width: 2,
  height: 2
}, _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
  d: "m7.926 10.477-.217.43s.002.053.08.075c.14.04.35.084.47.07.148-.017.23-.062.23-.062s.138-.235.158-.273c.092-.167-.084-.377-.35-.411-.276-.036-.37.171-.37.171Z",
  fill: "url(#s)"
}))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#t)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M7.912 11.02s.037-.44.113-.408c.272.114.438-.078.36-.187-.072-.096.118-.166.197-.053.078.11.316.292.308.305-.01.014-.375.331-.375.331s-.268.116-.297.116c-.028 0-.255-.027-.255-.027l-.051-.078Z",
  fill: "url(#u)"
}))), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "m7.845 11 .067.015a.953.953 0 0 0 .344.032 1.414 1.414 0 0 0 .204-.054l.02-.006.005-.001h.002v.004l.002.004h-.002c0 .001-.002.002-.005.002l-.019.006a1.413 1.413 0 0 1-.205.054.96.96 0 0 1-.349-.032 3.096 3.096 0 0 0-.095-.022.36.36 0 0 1-.06-.018.075.075 0 0 1-.034-.028.12.12 0 0 1-.016-.048l.01-.002a.11.11 0 0 0 .013.045c.007.01.017.018.03.024a.342.342 0 0 0 .06.018l.028.006Z",
  fill: "#FFDC9C"
})), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
  d: "M8.08 10.713c.02.081-.01.159-.068.175-.059.015-.125-.037-.146-.117-.021-.08.008-.159.068-.174.058-.017.124.036.145.117Z",
  fill: "url(#v)"
})), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
  d: "M8.063 10.849a.392.392 0 0 1-.238.232l-.15-.56c.028-.023.184-.009.314.08l.074.248Z",
  fill: "url(#w)"
})), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
  d: "M7.959 10.745c.041.155-.017.304-.13.335-.113.03-.238-.07-.28-.225-.042-.155.017-.304.13-.334.114-.03.239.07.28.224Z",
  fill: "#fff"
})), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
  d: "M7.901 10.76c.03.111-.012.219-.092.24-.081.021-.17-.05-.2-.16s.011-.218.092-.24c.08-.022.17.05.2.16Z",
  fill: "url(#x)"
})), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
  d: "M7.384 12.325c-.014.044-.054.07-.089.058-.035-.01-.053-.055-.04-.099.014-.043.054-.07.09-.058.035.011.053.055.04.099ZM11.88 11.22c-.092.044-1.114.547-1.352.605-.666.163-.826.03-.851.017-.077-.036-.033-.388.02-.44.11-.11.316-.089.66-.238.164-.07.734-.426.975-.395.179.023.42.084.57.133.102.034.069.273-.022.317Z",
  fill: "#21272A"
})), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
  d: "M9.859 11.888s.079-.29.144-.381c.065-.092.495-.1.663-.184.167-.086.65-.28.88-.347.204-.06.38-.08.398-.007.034.138-.02.317-.02.317s-1.064.632-1.382.657c-.319.022-.683-.055-.683-.055Z",
  fill: "url(#y)"
})), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
  d: "M7.105 13.897a.074.074 0 0 1-.049-.087s.208-.967.22-1.009c.01-.041.144.013.129.101l-.203.94a.073.073 0 0 1-.097.055Z",
  fill: "#697077"
})), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
  d: "M7.713 13.236a.415.415 0 0 0-.094-.013c.173.14.248.43.167.728-.088.327-.332.554-.575.552.042.034.09.06.143.073.27.072.57-.169.67-.538.099-.371-.04-.73-.31-.802Z",
  fill: "#A2A9B0"
})), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
  d: "M7.204 13.815c-.026.1.012.198.085.217.073.02.155-.045.181-.145.027-.1-.01-.198-.084-.217-.073-.02-.155.045-.182.145Z",
  fill: "#A2A9B0"
})), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
  d: "m7.289 14.032.144.039.097-.363-.144-.038-.097.362Z",
  fill: "#A2A9B0"
})), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
  d: "M7.346 13.853c-.027.1.011.198.084.217.074.02.155-.045.182-.146.027-.1-.011-.197-.084-.216-.074-.02-.155.045-.182.145Z",
  fill: "#697077"
})), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
  d: "m7.892 13.583-.373.1.187-.449-.16-.071-.187.448-.187-.348-.16.156.187.349-.374.1v.228l.374-.1-.186.448.159.07.187-.448.186.349.16-.156-.186-.35.373-.1v-.226Z",
  fill: "#697077"
})), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
  d: "M7.25 13.81c-.02.078.009.154.066.17.058.015.121-.037.142-.115.022-.079-.008-.155-.066-.17-.057-.015-.12.037-.141.115ZM7.892 13.583l.108.031-.373.1-.108-.031.373-.1ZM7.654 14.446l-.109-.031-.186-.349.108.032.187.348Z",
  fill: "#697077"
})), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
  d: "m8 13.614-.373.1.186-.45-.16-.07-.186.449-.187-.349-.16.157.187.348-.373.1v.228l.373-.1-.187.449.16.07.187-.448.187.348.16-.156-.187-.349.373-.1v-.227Z",
  fill: "#C1C7CD"
})), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
  d: "M7.36 13.841c-.022.079.007.155.065.17.057.016.12-.036.142-.114.021-.079-.009-.155-.066-.17-.058-.016-.122.035-.142.114Z",
  fill: "#C1C7CD"
})), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
  d: "M7.761 13.053c-.344-.092-.726.215-.852.685-.126.471.05.928.395 1.02.345.092.727-.214.853-.685.126-.47-.05-.927-.396-1.02Zm.263.985c-.1.37-.4.611-.67.538-.271-.072-.41-.432-.312-.802.1-.37.4-.611.67-.538.272.072.41.431.312.802Z",
  fill: "#21272A"
})), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
  d: "M7.265 13.823c-.049.18.019.354.15.389.132.035.278-.082.325-.261.048-.18-.02-.354-.151-.389-.132-.035-.277.082-.324.261Z",
  fill: "#697077"
})), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
  d: "m7.415 14.212.068.018.174-.65-.067-.018-.175.65Z",
  fill: "#697077"
})), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
  d: "M7.327 13.84c-.048.18.02.353.15.388.132.036.278-.081.325-.26.048-.18-.02-.354-.151-.39-.13-.034-.276.082-.324.262Z",
  fill: "#343A3F"
})), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
  d: "M7.304 14.759c-.344-.093-.521-.549-.395-1.02.126-.47.508-.777.852-.685a.49.49 0 0 1 .15.07.995.995 0 0 0-.607-.171c-.304.007-.607.291-.716.701-.11.408.01.806.269.964a.991.991 0 0 0 .61.155.513.513 0 0 1-.163-.014Z",
  fill: "#343A3F"
})), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
  d: "M7.564 14.009a.074.074 0 0 1-.05-.086l.223-1.022c.009-.034.147.004.127.107-.015.078-.204.945-.204.945a.073.073 0 0 1-.096.056Z",
  fill: "#343A3F"
})), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.1,
  fill: "#121619"
}, /*#__PURE__*/React.createElement("path", {
  d: "m11.266 9.696-.063-.017.524-.14.064.016-.525.141ZM11.452 9.746l-.064-.018.524-.14.064.017-.524.141ZM11.638 9.795l-.064-.017.523-.14.064.017-.523.14ZM11.823 9.845l-.064-.017.524-.14.064.016-.524.141Z"
}))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "b",
  x1: 10.988,
  y1: 9.053,
  x2: 2.758,
  y2: 0.823,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FF7044"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F92814"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "d",
  x1: 14.535,
  y1: 7.312,
  x2: 2.025,
  y2: 8.55,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#D0E9FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#fff"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "e",
  x1: 17.352,
  y1: 6.938,
  x2: 12.553,
  y2: 7.11,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#799EC0"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#87B0D7"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "f",
  x1: 14.656,
  y1: 6.756,
  x2: 14.656,
  y2: 8.943,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#A0DBFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#91D5FF",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "g",
  x1: 15.238,
  y1: 6.756,
  x2: 15.238,
  y2: 8.438,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#A0DBFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#91D5FF",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "h",
  x1: 14.656,
  y1: 8.162,
  x2: 14.656,
  y2: 8.942,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#A0DBFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#91D5FF",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "i",
  x1: 4.457,
  y1: 3.513,
  x2: 4.823,
  y2: 7.853,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFE3C7"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FF7F22"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "j",
  x1: 8.541,
  y1: 7.281,
  x2: 8.541,
  y2: 13.006,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#A0DBFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#91D5FF",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "k",
  x1: 4.505,
  y1: 0.037,
  x2: 5.808,
  y2: 8.308,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFE3C7"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FF7F22"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "l",
  x1: 9.824,
  y1: 0.002,
  x2: 11.183,
  y2: 8.391,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFA549"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.604,
  stopColor: "#EC502D"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.953,
  stopColor: "#9C6357"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "m",
  x1: 7.489,
  y1: 10.956,
  x2: 7.881,
  y2: 12.054,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFE0AC"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FB9346"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "n",
  x1: 7.583,
  y1: 9.118,
  x2: 9.201,
  y2: 15.148,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFA549"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.604,
  stopColor: "#EC502D"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.953,
  stopColor: "#9C6357"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "p",
  x1: 7.84,
  y1: 10.677,
  x2: 8.715,
  y2: 14.215,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFA549"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.696,
  stopColor: "#EB5837"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.953,
  stopColor: "#79220E"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "q",
  x1: 10.155,
  y1: 11.661,
  x2: 10.155,
  y2: 13.383,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#4D5358"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#4D5358",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "r",
  x1: 8.191,
  y1: 10.302,
  x2: 8.191,
  y2: 11.054,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFF3DF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FF9E00"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "s",
  x1: 8.191,
  y1: 10.302,
  x2: 8.191,
  y2: 11.054,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFD591"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FFD084"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "u",
  x1: 7.803,
  y1: 10.485,
  x2: 9.373,
  y2: 12.652,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFA549"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.604,
  stopColor: "#EC502D"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.915,
  stopColor: "#460F02"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "v",
  x1: 7.884,
  y1: 10.424,
  x2: 8.177,
  y2: 10.884,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFA549"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.604,
  stopColor: "#EC502D"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.953,
  stopColor: "#9C6357"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "w",
  x1: 7.717,
  y1: 10.187,
  x2: 8.304,
  y2: 11.007,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFA549"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.604,
  stopColor: "#EC502D"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.953,
  stopColor: "#9C6357"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "x",
  x1: 7.755,
  y1: 10.596,
  x2: 7.808,
  y2: 11.279,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#009DFE"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#30B0FF",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "y",
  x1: 11.409,
  y1: 11.159,
  x2: 9.969,
  y2: 12.959,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#21272A"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#3D4347"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  transform: "translate(.5)",
  d: "M0 0h16v16H0z"
})))));
export default SvgHub;